import { render, staticRenderFns } from "./ChallengesDestinations.vue?vue&type=template&id=3abc24d1&"
import script from "./ChallengesDestinations.vue?vue&type=script&lang=js&"
export * from "./ChallengesDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports